// extracted by mini-css-extract-plugin
export default {"container":"T82gd81Ypp4aHlsYIfaZ"};